<template>
	<transition name="fade">
		<div id="new-form" class="modal-box" v-if="config.show" >
			<div class="modal modal-lg p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">새 전자우편 양식 작성하기</h2>
					<a href="#none" class="close" @click="$emit('close')">&times;</a>
					<div class="config">
						<button class="btn-sm round">안내</button>
					</div>
				</div>
				<div class="modal-body p-15" style="min-height: 1px;">
					<div class="send-box full-width">
						<div class="input-group on-border round full-width m-b-10">
							<span class="input-group-addon">
								<input v-model="title"
								class="form-control m-b-0 no-border text-left"
								type="text"
								placeholder="제목을 입력하세요.">
							</span>
						</div>
					</div>

					<div class="text-edit">
						<textarea class="full-width editorContent" cols="30" rows="4"></textarea>
					</div>
				</div>

				<div class="modal-footer p-15 m-t-30 clearfix">
					<button @click="regEmailForm()" class="btn pull-right round" type="button">저장하기</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import Axios from "axios";
import server from '../statics/server'// eslint-disable-line no-unused-vars
import _ from 'lodash'// eslint-disable-line no-unused-vars
import moment from 'moment'// eslint-disable-line no-unused-vars

export default {
	name:"ModalEmailFormRegister",

	mounted: function() {
		let that = this;
		window.tinymce.init({
			selector: '.editorContent',
			height: 500,
			branding: false,
			plugins: [
				"advlist autolink lists link image charmap print preview anchor",
				"searchreplace visualblocks code fullscreen",
				"insertdatetime media table paste imagetools wordcount lineheight"
				],
				toolbar_mode: 'wrap',
				toolbar: "| insertfile undo redo | styleselect fontselect fontsizeselect lineheight| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image ",
				fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 30pt 32pt 34pt 36pt 38pt 40pt",
				lineheight_formats: "1 1.5 2 2.5 3 3.5 4 4.5 5",
			images_upload_handler: function(blobInfo, success) {
				const formData = new FormData();
				formData.append('file', blobInfo.blob(), blobInfo.filename());
				Axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
					success("/download/" + response.data);
				});
			},
			setup: function(editor) {
				editor.on('init', function() {
					editor.setContent(that.content);
				});
				editor.on("change", function() {
					that.content = editor.getContent();
				})
			}
		}).then((r) => {this.editorContent = r[0]});
	},

	components: {
	},

	default: function() {
		return {
			name: this.name,
			show: false
		}
	},

	props: {
		config: Object
	},

	data(){
		return {
			title : '',
			content : '',
			editorContent: null
		}
	},
	methods: {
		regEmailForm(){
			const self = this;
			let email_form = {
				title : this.title,
				content : this.content,
				shareEnabled : 0,
				// atchFileId : 0,
				//mberId : '',
			}

			server.putAxios('sys/emailTempl', email_form, ({data, err}) => {
				err; data;
				self.$emit('close');
				self.$emit('refresh');
			});
		},
		parseShareEnabled(){
			return 0;
		},
		uploadFile(){

		},



	},
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>